import { render, staticRenderFns } from "./Oran.vue?vue&type=template&id=0a33d45a"
import script from "./Oran.vue?vue&type=script&lang=ts"
export * from "./Oran.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports